<template>
    <div class="bottomall">
        <div class="bottom">
            <div class="bottom-head">
                <div class="b-h-head">
                    <div>
                        <h1>度云科技，您的企业营销增长新选择</h1>
                    </div>
                </div>
                <div class="b-h-foot">
                    <div class="b-body">
                        <div class="b-banner" v-for="(item, index) in body" :key="index">
                            <div class="b-b-head">{{ item.name }}</div>
                            <div class="b-b-body">{{ item.title }}</div>
                            <div class="b-b-foot">
                                <div v-for="(it, i) in item.foot" @click="jump(it,i)" :key="i">{{ it.name }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="free" @click="jumpd()">免费体验</div>
                </div>
            </div>
            <div class="bottom-foot">
                <div class="b-f-body">
                    <div class="b-f-b-head">
                        <div class="b-h-left">
                            <div class="phone">售前咨询热线</div>
                            <div class="phonenum">15814503065</div>
                            <div class="phonebt">售前在线咨询</div>
                            <div class="phonimg"> <img src="../../assets/img/服务.png" alt=""></div>
                        </div>
                        <div class="b-h-right">
                            <div class="body" v-for="(item, index) in bottom" :key="index">
                                <div class="title">{{ item.name }}</div>
                                <div class="product" v-for="(it, i) in item.product" :key="i" @click="jump(it,i)">{{ it.name }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="b-f-b-foot">
                        <div>© 2026 粤ICP备2026129343号 广州度云科技服务有限公司</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            body: [{ name: "客悦·ONE", title: '营销服务全旅程AI应用', foot: [{ name: '智能外呼' ,url:'two'}, { name: "智能客服",url:'one'}, { name: "客户洞察",url:'tree' }] }
                , { name: "度云科技GEO服务", title: '紧跟时代大模型搜索抓取，专人服务，流量获取。', foot: [{ name: '了解详情',url:"massage" }] }
                , { name: "百度智能云服务器", title: '大厂云服务能力，稳定效率高。', foot: [{ name: '了解详情',url:'call'}] }],
            bottom: [{ name: "产品", product: [{ name: '智能客服',url:'one'}, { name: "智能外呼",url:'two'}, { name: "精准洞察",url:'tree' }, { name: "度云科技GEO服务",url:'free'}, { name: "百度智能云服务器",url:'free'}] },
            { name: "服务与支持", product: [{ name: "文档中心",url:'free'}, { name: "入门指南",url:'free' }] },]
        }
    },
    methods: {
        jumpd() {
            if (window.location.href != this.$route.query.id) {
                this.$router.push({ name: 'free', query: { id: window.location.href } })
            }
        },
        jump(it,i) {
            if (window.location.href != this.$route.query.id) {
                this.$router.push({ name: it.url, query: { id: window.location.href } })
            }
        },
    },
    mounted() {
    },
    beforeDestroy() {

    }
}
</script>

<style lang="scss">
.bottomall {
    width: 100%;
    min-width: 1200px;
    bottom: 0;
    display: inline-block;

    .phonimg {
        display: inline-block;
        width: 80%;
        margin-top: 30px;

        img {
            width: 100%;
        }
    }

    .bottom {
        width: 100%;
        min-width: 1200px;
        display: inline-block;

        .bottom-head {
            background-color: #f2f6fc;
            text-align: center;
            display: inline-block;
            width: 100%;

            .b-h-head {
                margin-top: 70px;
                font-size: 18px;
                color: #091221;
                font-weight: 600;
                -webkit-background-clip: text;
                background-image: linear-gradient(-80deg, #3ed2fd, #2468f2 60%);
                -webkit-text-fill-color: transparent;
            }

            .b-body {
                width: 84%;
                margin: 0 auto;
                background-color: white;
                padding: 20px 30px;
                border-radius: 15px;
                display: flex;
                justify-content: space-between;
                margin-top: 24px;
                box-shadow: 0px 0px 20px rgb(244, 244, 244);

                .b-b-body {
                    margin-top: 6px;
                    font-size: 12px;
                    color: #4d4d4d;
                    width: 100%;
                    text-align: left;
                    display: flex;
                }

                .b-banner {
                    width: 30%;

                    .b-banner>div {
                        width: 100%;
                        text-align: left;
                        display: flex;
                    }
                }

                .b-b-head {
                    font-size: 18px;
                    font-weight: 700;
                    width: 100%;
                    text-align: left;
                    display: flex;
                }

                .b-b-foot {
                    margin-top: 6px;
                    font-size: 14px;
                    display: inline-block;
                    width: 100%;
                    text-align: left;
                    display: flex;

                    div {
                        display: inline-block;
                        font-weight: 700;
                        margin-right: 10px;
                    }
                }

                .b-b-foot>div:hover {
                    cursor: pointer;
                    color: #2468f2;
                }

            }

            .free {
                display: inline-block;
                margin: 0 auto;
                background-color: black;
                color: white;
                border-radius: 8px;
                padding: 12px 38px;
                font-size: 14px;
                font-weight: 600;
                margin-top: 24px;
                height: 20px;
                line-height: 20px;
            }

            .free:hover {
                cursor: pointer;
                background-color: rgb(46, 46, 46);
            }

            .b-h-foot {
                padding-bottom: 30px;
            }
        }



        .bottom-foot {
            background-color: #161b25;
            width: 100%;
            color: white;

            .b-f-b-head {
                padding-top: 30px;
                display: flex;
                padding-bottom: 20px;

                .b-h-left {
                    width: 20%;
                    text-align: left;
                    border-right: 1px solid rgb(79, 79, 79);

                    .phone {
                        font-size: 18px;
                    }

                    .phonenum {
                        font-size: 24px;
                    }

                    .phonebt {
                        margin-top: 10px;
                        font-size: 14px;
                        color: rgb(158, 158, 158);
                    }

                    .phonebt:hover {
                        cursor: pointer;
                        color: #2468f2;
                    }
                }

                .b-h-right {
                    display: flex;
                    margin-left: 60px;
                    width: 80%;
                    justify-content: space-around;

                    div {
                        text-align: center;
                    }

                    .body {
                        .title {
                            font-size: 16px;
                        }

                        .product {
                            font-size: 14px;
                            color: rgb(158, 158, 158);
                            margin-top: 10px;
                        }

                        .product:hover {
                            cursor: pointer;
                            color: #2468f2;
                        }
                    }
                }
            }

            .b-f-body {
                width: 90%;
                margin: 0 auto;
            }

            .b-f-b-foot {
                text-align: center;
                padding: 20px 0;
                border-top: 1px solid rgb(79, 79, 79);
                color: rgb(79, 79, 79);

            }
        }
    }
}
</style>